(() => {
  "use strict";

  const MW = 749;
  const CK = "u";
  const CK_TTL_S = 2592000;

  const MOUNT_SEL = "#TIL_LP_MOUNT";
  const WHITE_TPL = "#TIL_LP_WHITE_TPL";
  const BLACK_TPL = "#TIL_LP_BLACK_TPL";

  const ROOT_ID = "TIL_LP_RENDERED_ROOT";

  const ED = !!(window.Shopify && Shopify.designMode);

  const nowS = () => Math.floor(Date.now() / 1000);

  function isMobile() {
    try { return matchMedia(`(max-width:${MW}px)`).matches; } catch { return false; }
  }

  function readCookie(name) {
    try {
      const s = document.cookie || "";
      const a = s.split(/;\s*/);
      for (const p of a) {
        const j = p.indexOf("=");
        if (j > 0 && p.slice(0, j) === name) return decodeURIComponent(p.slice(j + 1));
      }
    } catch {}
    return "";
  }

  function parseCookieU(uVal) {
    try {
      if (!uVal) return null;
      const dot = uVal.indexOf(".");
      if (dot < 1) return null;
      const b64 = uVal.slice(0, dot);

      const obj = JSON.parse(atob(b64));
      if (!obj || typeof obj.t !== "number") return null;

      const age = nowS() - obj.t;
      if (age < 0 || age > CK_TTL_S) return null;

      const m = Number(obj.m) === 1 ? 1 : 0;
      return { m };
    } catch {
      return null;
    }
  }

  function shouldBlack() {
    if (ED) return false;
    if (!isMobile()) return false;
    const u = readCookie(CK);
    const parsed = parseCookieU(u);
    return !!(parsed && parsed.m === 1);
  }

  function getMount() {
    try { return document.querySelector(MOUNT_SEL); } catch { return null; }
  }

  function cloneTpl(sel) {
    const t = document.querySelector(sel);
    if (!t || !("content" in t)) return null;
    return t.content.cloneNode(true);
  }

  function clearRendered(mount) {
    if (!mount) return;
    const old = mount.querySelector(`#${ROOT_ID}`);
    if (old) old.remove();
  }

  function render(mode) {
    const mount = getMount();
    if (!mount) return;

    const existing = mount.getAttribute("data-til-mode") || "";
    if (existing === mode && mount.querySelector(`#${ROOT_ID}`)) return;

    clearRendered(mount);

    const frag = cloneTpl(mode === "black" ? BLACK_TPL : WHITE_TPL);
    if (!frag) return;

    const wrap = document.createElement("div");
    wrap.id = ROOT_ID;
    wrap.appendChild(frag);

    mount.appendChild(wrap);
    mount.setAttribute("data-til-mode", mode);

    if (mode === "black") initCarousels(mount);
  }

  function initCarousels(scope) {
    const car = (scope || document).querySelector("[data-til-car]");
    if (!car || car.getAttribute("data-inited") === "1") return;
    car.setAttribute("data-inited", "1");

    const track = car.querySelector("[data-til-track]");
    const dots = Array.from(car.querySelectorAll(".TILLP__dot"));
    const prev = car.querySelector("[data-til-prev]");
    const next = car.querySelector("[data-til-next]");
    if (!track) return;

    const count = dots.length;
    if (count <= 1) {
      const dotsWrap = car.querySelector("[data-til-dots]");
      if (dotsWrap) dotsWrap.style.display = "none";
      if (prev) prev.style.display = "none";
      if (next) next.style.display = "none";
      return;
    }

    const go = (idx) => {
      const w = track.clientWidth || 1;
      track.scrollTo({ left: w * idx, behavior: "smooth" });
    };

    if (prev) prev.addEventListener("click", () => {
      const idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
      go(Math.max(0, idx - 1));
    });

    if (next) next.addEventListener("click", () => {
      const idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
      go(Math.min(count - 1, idx + 1));
    });

    dots.forEach((b, i) => b.addEventListener("click", () => go(i)));

    let raf = 0;
    const sync = () => {
      raf = 0;
      const idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
      dots.forEach((b, i) => b.setAttribute("aria-current", i === idx ? "true" : "false"));
    };

    track.addEventListener("scroll", () => {
      if (raf) return;
      raf = requestAnimationFrame(sync);
    });

    addEventListener("resize", () => {
      const idx = dots.findIndex((b) => b.getAttribute("aria-current") === "true");
      track.scrollTo({ left: (track.clientWidth || 1) * Math.max(0, idx), behavior: "auto" });
    }, { passive: true });
  }

  let last = { mobile: null, black: null };
  let raf = 0;

  function apply() {
    const mobile = isMobile();
    const black = shouldBlack();
    const mode = mobile && black ? "black" : "white";

    if (last.mobile === mobile && last.black === black) {
      const mount = getMount();
      if (mount && !mount.querySelector(`#${ROOT_ID}`)) render(mode);
      return;
    }
    last = { mobile, black };
    render(mode);
  }

  function sched() {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      apply();
    });
  }

  let ckPrev = "";
  setInterval(() => {
    if (ED) return;
    const v = readCookie(CK);
    if (v !== ckPrev) {
      ckPrev = v;
      sched();
    }
  }, 800);

  const mql = window.matchMedia ? window.matchMedia(`(max-width:${MW}px)`) : null;
  if (mql) {
    const onChange = () => sched();
    try { mql.addEventListener("change", onChange); } catch { try { mql.addListener(onChange); } catch {} }
  }

  addEventListener("resize", sched, { passive: true });
  addEventListener("orientationchange", sched, { passive: true });
  addEventListener("pageshow", sched, { passive: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", sched, { once: true });
  } else {
    sched();
  }

  window.__til_lp = { apply: () => sched(), black: () => shouldBlack(), mobile: () => isMobile() };
})();
